module.exports = __webpack_public_path__ + "img/logo.f0def654.png";